import ajax from "@/common/ajax.js";
import { skk_axios as axios } from "../common/ajax";

// export default {
//   login(data) {
//     return ajax.request.post("/api/account/login", data);
//   },
// };

//登录
export function login(data) {
  return ajax.request.post("/api/account/login", data);
}

//注册
export function register(data) {
  return ajax.request.post("/api/account/register", data);
}

//忘记密码
export function forgotPassword(data) {
  return ajax.request.post("/api/account/forgotPassword", data);
}

// 获取登记须知
export function getClause() {
  return ajax.request.get("/api/common/getClause");
}

//游客页 搜索
export function search(data) {
  return ajax.request.post("/api/index/search", data);
}

//图片验证码
export const getCaptchaImage = () =>
  ajax.request.get("/api/common/getCaptchaImage");

// /**
//  * 首页
//  *  获取企业信息
//  * @param {*} params
//  * @returns
//  */
// 废弃的接口
// export const getHomeCompanyInfo = (params) => {
//   return axios({
//     url: "/api/index/details",
//     method: "get",
//     params,
//   });
// };

// 不要删除！！！/**
//  * post
//  * @param {*} data
//  * @returns
//  */
// export const getHomeCompanyInfosss = (data) => {
//   return axios({
//     url: "/api/index/details",
//     method: "post",
//     data,
//   });
// };

/**
 * 首页随机展示
 * @param {*} params
 * @returns
 */
export const rangeCompanyList = (params) => {
  return axios({
    url: "/api/index/rangeCompanyList",
    method: "get",
    params,
  });
};

/**
 * 获取3级地址
 * @param {*} params
 * @returns
 */
export const get3levelArea = (params) => {
  return axios({
    url: "/api/common/getAddressList",
    method: "get",
    params,
  });
};

/*
 *设置《须知》已读
 * @param {*} params
 * @returns
 */
export const atClause = (params) => {
  return axios({
    url: "/api/common/atClause",
    method: "get",
    params,
  });
};
